export default __webpack_public_path__ + "static/media/bullpen.c6f45786.png";